import {Component, OnInit} from '@angular/core';
import {MessageService} from 'primeng/api';
import {TableModule} from 'primeng/table';
import {UserErrors} from '../models';
import {MiniBookAdminService} from '../service/mini-book-admin.service';
import {Room} from '../shared/Room';

@Component({
    selector: 'edu-udo-itmc-dev-mini-book-rooms',
    templateUrl: './rooms.component.html',
    styleUrls: ['./rooms.component.css'],
    standalone: false
})
export class RoomsComponent implements OnInit {

  rooms: Room[] = []
  roomErrors?: UserErrors;
  roomInError?: Room;

  clonedRoom?: Room;

  editing: boolean = false;

  rowTrackBy = (room: Room) => room.id;

  constructor(
    private adminService: MiniBookAdminService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.adminService.rooms.getRooms().subscribe({
      next: value => this.rooms = value
    });
  }

  deleteRoom(room: Room) {
    this.adminService.rooms.deleteRoom(room.id, false).subscribe({
      next: () => this.rooms = this.rooms.filter(value => value.id !== room.id),
      error: err => {
        this.roomInError = room;
        if ('error' in err && typeof err.error == 'object' && 'type' in err.error && err.error.type === 'UserErrors') {
          this.roomErrors = err.error;
        } else {
          const message: any = {
            type: 'PlainErrorMessage',
            summary: 'Fehler bei der Kommunikation mit dem Backend',
            detail: err.message
          };
          this.roomErrors = {
            type: 'UserErrors',
            messages: [message]
          };
        }
      }
    });
  }

  clearRoomError(executeForced: boolean) {
    const room = this.roomInError;
    this.roomErrors = undefined;
    this.roomInError = undefined;
    if (executeForced && room) {
      this.adminService.rooms.deleteRoom(room.id, executeForced).subscribe({
        next: () => {
          this.rooms = this.rooms.filter(value => value.id !== room.id);
          this.messageService.add({
            summary: 'Raum wurde entfernt.',
            detail: 'Entfernen des Raums wurde erzwungen.',
            severity: 'success'
          });
        },
        error: err => {
          this.messageService.add({
            summary: 'Fehler bei der Kommunikation mit dem Backend',
            detail: err.message,
            severity: 'error'
          });
        }
      });
    }
  }

  createRoom(table: any) {
    const newRoom = new Room();
    this.rooms.push(newRoom);
    table.initRowEdit(newRoom);
    this.editing = true;
  }

  updateRoom(room: Room) {
    if (this.clonedRoom) {
      this.adminService.rooms.updateRoom(room.id, room).subscribe({
        next: value => {
          room.fromJson(value.toJson());
          this.messageService.add({
            summary: 'Änderungen wurden gespeichert.',
            severity: 'success'
          });
        },
        error: err => {
          this.messageService.add({
            summary: 'Fehler bei der Kommunikation mit dem Backend',
            detail: err.message,
            severity: 'error'
          });
        }
      });
      this.clonedRoom = undefined;
    } else {
      this.adminService.rooms.createRoom(room).subscribe({
        next: value => {
          room.fromJson(value.toJson());
          this.messageService.add({
            summary: 'Raum wurde hinzugefügt.',
            severity: 'success'
          });
        },
        error: err => {
          this.messageService.add({
            summary: 'Fehler bei der Kommunikation mit dem Backend',
            detail: err.message,
            severity: 'error'
          });
        }
      })
    }
    this.editing = false;
  }

  onRoomEditInit(room: Room) {
    this.clonedRoom = Room.createFromJson(room.toJson());
    this.editing = true;
  }

  onRoomEditCancel(room: Room) {
    if (this.clonedRoom) {
      room.fromJson(this.clonedRoom.toJson());
      this.clonedRoom = undefined;
    } else {
      this.rooms = this.rooms.filter(value => value.id !== 0);
    }
    this.editing = false;
  }
}
